/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderInfoForCombineVo } from './OrderInfoForCombineVo';
import {
    OrderInfoForCombineVoFromJSON,
    OrderInfoForCombineVoFromJSONTyped,
    OrderInfoForCombineVoToJSON,
    OrderInfoForCombineVoToJSONTyped,
} from './OrderInfoForCombineVo';

/**
 * 
 * @export
 * @interface ResponseOrderInfoForCombineVo
 */
export interface ResponseOrderInfoForCombineVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseOrderInfoForCombineVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseOrderInfoForCombineVo
     */
    message?: string;
    /**
     * 
     * @type {OrderInfoForCombineVo}
     * @memberof ResponseOrderInfoForCombineVo
     */
    data?: OrderInfoForCombineVo;
}

/**
 * Check if a given object implements the ResponseOrderInfoForCombineVo interface.
 */
export function instanceOfResponseOrderInfoForCombineVo(value: object): value is ResponseOrderInfoForCombineVo {
    return true;
}

export function ResponseOrderInfoForCombineVoFromJSON(json: any): ResponseOrderInfoForCombineVo {
    return ResponseOrderInfoForCombineVoFromJSONTyped(json, false);
}

export function ResponseOrderInfoForCombineVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseOrderInfoForCombineVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : OrderInfoForCombineVoFromJSON(json['data']),
    };
}

export function ResponseOrderInfoForCombineVoToJSON(json: any): ResponseOrderInfoForCombineVo {
    return ResponseOrderInfoForCombineVoToJSONTyped(json, false);
}

export function ResponseOrderInfoForCombineVoToJSONTyped(value?: ResponseOrderInfoForCombineVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': OrderInfoForCombineVoToJSON(value['data']),
    };
}

